import { ExtendedNextLink } from 'components/Basic/ExtendedNextLink/ExtendedNextLink';
import Pill from 'components/Basic/Pill/Pill';
import { NotImplementedYetHandler } from 'components/Helpers/NotImplementedYet';
import { QuickContactWrapper } from 'components/Layout/Header/HeaderBottom/UserMenu/B2b/QuickContactWrapper';
import { MenuItemProps } from 'components/Layout/Header/HeaderBottom/UserMenu/UserMenu';
import { useAuth } from 'hooks/auth/useAuth';
import { useCurrentUserData } from 'hooks/user/useCurrentUserData';
import useTranslation from 'next-translate/useTranslation';
import { forwardRef } from 'react';
import { twJoin } from 'tailwind-merge';

type UserMenuMobileProps = {
    menuItems: MenuItemProps[];
};

const itemTwClass =
    'relative min-w-[280px] py-3 pl-14 leading-6 text-primary tracking-wider no-underline border-b border-gray hover:no-underline';

const UserMenuMobile = forwardRef<HTMLDivElement, UserMenuMobileProps>(({ menuItems }, ref) => {
    const { t } = useTranslation();
    const { logout } = useAuth();
    const { user } = useCurrentUserData();

    return (
        <div className="fixed left-0 right-0 top-[200px] z-menu w-screen" ref={ref}>
            <div className="absolute right-0 top-0 z-menu flex w-full max-w-full flex-col overflow-hidden bg-white shadow-mobileMenu transition-all">
                {menuItems
                    .filter((menuItem) => menuItem.show)
                    .map((menuItem) => {
                        if (menuItem.link === null) {
                            return (
                                <ExtendedNextLink
                                    key={menuItem.title}
                                    className={itemTwClass}
                                    href="#"
                                    onClick={NotImplementedYetHandler}
                                >
                                    <>
                                        {menuItem.count !== null && (
                                            <Pill
                                                className="absolute left-6 top-1/2 -translate-y-1/2 leading-none"
                                                value={menuItem.count}
                                            />
                                        )}
                                        {menuItem.title}
                                    </>
                                </ExtendedNextLink>
                            );
                        }

                        return (
                            <ExtendedNextLink key={menuItem.title} className={itemTwClass} href={menuItem.link}>
                                <>
                                    {menuItem.count !== null && (
                                        <Pill
                                            className="absolute left-6 top-1/2 -translate-y-1/2 leading-none"
                                            value={menuItem.count}
                                        />
                                    )}
                                    {menuItem.title}
                                </>
                            </ExtendedNextLink>
                        );
                    })}
                <a className={twJoin(itemTwClass, 'bg-grayLighter')} tabIndex={0} onClick={logout}>
                    {t('Logout')} {user?.firstName} {user?.lastName}
                </a>
                <QuickContactWrapper
                    manager={user?.defaultDeliveryAddress?.manager ?? null}
                    quickContact={user?.quickContact ?? null}
                    type="menu-mobile"
                />
            </div>
        </div>
    );
});

UserMenuMobile.displayName = 'UserMenuMobile';

export default UserMenuMobile;
